module.exports = __webpack_public_path__ + "static/media/campaigns-running-icon.a28126eb.svg";